<template>
  <div class="combobox-processing-item-error-display pointer-events-auto">
    <PAlert
      class="mr-2"
      size="small"
      :type="modelValue.weight === ExceptionWeights.ERROR ? AlertTypes.ERROR : AlertTypes.WARNING"
      :title="modelValue.getTitle()"
      :description="modelValue.getMessage()"
    >
      <template v-if="modelValue.weight === ExceptionWeights.WARNING" #actions="{ buttonColor }">
        <GeneralButton :color="buttonColor" size="small" @click="$emit('clearError')">
          Melding sluiten
        </GeneralButton>
      </template>
    </PAlert>
  </div>
</template>

<script setup lang="ts">
import { ExceptionWeights } from "@/enums/exceptions/exception-weights"
import { AlertTypes } from "@/interfaces/component/alert.interface"
import PAlert from "@/components/elements/PAlert.vue"
import GeneralButton from "@/components/inputs/GeneralButton.vue"
import type { BaseException } from "@/exceptions/base-exception.exception"

const modelValue = defineModel<BaseException>({ required: true })

defineEmits(["clearError"])
</script>

<style scoped></style>
